import React, { useContext } from 'react';
import { useMutation, useQuery } from 'react-query';
import { Auth } from '@aws-amplify/auth';
import axiosClient from './http/axios-client';

const AuthCtx = React.createContext({});

export function AuthProvider(props) {
  const {
    data: user,
    isLoading: userIsAuthenticating,
    isIdle: userIsIdle,
    refetch: getMe,
  } = useQuery(
    [ 'user' ],
    () => { return axiosClient.get('admin-tool-users/me'); },
    {
      enabled: false,
      onError() {
        return Auth.signOut();
      },
    },
  );

  const [ deliveryDetails, setDeliveryDetails ] = React.useState(null);
  const [ aux, setAux ] = React.useState(null);

  const {
    mutateAsync: authenticate,
  } = useMutation(({ username, password }) => {
    return Auth.signIn(username, password).then(() => {
      setAux(null);
    }).catch(() => {
      setAux((prev) => { return { ...prev, username, password }; });
    });
  }, {
    onSuccess() {
      return getMe();
    },
  });

  const userIsLoggedIn = !!user;

  const forgotPassword = ({ username }) => {
    setAux((prev) => { return { ...prev, username }; });
    return Auth.forgotPassword(username)
      .then(setDeliveryDetails);
  };

  const forgotPasswordSubmit = ({ code, newPassword }) => {
    return Auth.forgotPasswordSubmit(aux.username, code, newPassword)
      .then(() => {
        setAux((prev) => { console.log('new password', newPassword); return { ...prev, password: newPassword }; });
      });
  };

  const ctx = {
    user,
    authenticate,
    userIsAuthenticating,
    userIsLoggedIn,
    userIsIdle,
    deliveryDetails,
    forgotPasswordSubmit,
    getMe,
    forgotPassword,
  };

  return (
    <AuthCtx.Provider value={ ctx }>
      {props.children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => {
  const {
    user,
    authenticate,
    userIsAuthenticating,
    userIsLoggedIn,
    deliveryDetails,
    getMe,
    forgotPassword,
    forgotPasswordSubmit,
  } = useContext(AuthCtx);

  return {
    user,
    authenticate,
    userIsAuthenticating,
    deliveryDetails,
    userIsLoggedIn,
    getMe,
    forgotPassword,
    forgotPasswordSubmit,
  };
};
